export default __webpack_public_path__ + "static/media/invoiceGen.df4c7f06.png";